import React from 'react';
import styled from 'styled-components';

export const ProgressBar = styled.div`
    width: 100%;
    height: 4px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
`;

export const ProgressFill = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${props => props.progress || 0}%;
    background: linear-gradient(90deg, rgba(244, 212, 163, 0.6) 0%, rgba(244, 212, 163, 0.4) 100%);
    border-radius: 2px;
    transition: width 0.1s linear;
`;

export const TimeDisplay = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 0.7rem;
    color: rgba(244, 212, 163, 0.8);
    font-family: 'Courier New', monospace;
`;

const ProgressBarComponent = ({ progress, currentTime, duration, onMouseDown }) => {
    const formatTime = (seconds) => {
        if (!seconds || isNaN(seconds)) return '0:00';
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <ProgressBar onMouseDown={onMouseDown}>
                <ProgressFill progress={progress} />
            </ProgressBar>
            <TimeDisplay>
                <span>{formatTime(currentTime)}</span>
                <span>{formatTime(duration)}</span>
            </TimeDisplay>
        </>
    );
};

export default ProgressBarComponent;

